import React from "react";
import styles from "./styles/notfound.module.css";
import { useEffect } from "react";
import errorImg from "./styles/img/404.svg";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useContext } from "react";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { useAuth } from "../../Context/AuthContext";
import config from "../../config";
import { formattingRedirectionUrl } from "../../Utils/redirectingUrl";

export function NotFound() {
  const navigate = useNavigate();
  // useEffect(()=>{
  //     setTimeout(() => {
  //         navigate('/')
  //     }, 5000);
  // }, [])
  const auth = useAuth();
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(websiteCurrentLang.content.notFound);
  useEffect(() => {
    setContent(websiteCurrentLang.content.notFound);
  }, [websiteCurrentLang]);
  return (
    <div className={styles.main}>
      <img alt="" className={styles.error_img} src={errorImg} />
      <div style={{ fontSize: "26px", fontWeight: "500px" }}>
        {content?.sorry_page_not_found}
      </div>
      <div
        onClick={() => {
          if (auth?.otp === true) {
            navigate("/user/dashboard");
          } else {
            window.location.href = formattingRedirectionUrl("");
          }
        }}
        className={styles.blue_button}
      >
        {content.notFoundButton}
      </div>
    </div>
  );
}
